const fr = {
  home: "Accueil",
  your_clients: "Vos Clients",
  sort_clients: "Trier les Clients",
  all_matters: "Tous les Dossiers",
  expiry_dates: "Dates d’expiration",
  upcoming_expiry: "Dates d’échéance et délais à venir",
  extension_requested: "Prolongation demandée",
  help_center: "Centre d’aide",
  contact_us: "Nous contacter",
  contact_It: "Contactez notre service d’assistance",
  client_number: "Numéro du Client",
  client_name: "Nom du Client",
  lawyer: "Avocat",
  filter: "Filtrer",
  sort: "Trier",
  matter_description: "Description du Dossier",
  your_matters: "Vos dossiers",
  filter_matters: "Filtrer les dossiers",
  sort_matters: "Trier les dossiers",
  new_matter: "Nouveau dossier",
  total_matter: "Nombre Total de Dossiers",
  matters: "Dossiers",
  matter_number: "Numéro de Dossier",
  applicant_name: "Nom du Demandeur",
  description: "Description",
  created_on: "Créé le",
  status: "Statut",
  questionnaires: "Questionnaires",
  documents: "Documents",
  filter_questionnaires: "Filtrer les Questionnaires",
  sort_questionnaires: "Trier les Questionnaires",
  try_questionnaire: "Recherchez « questionnaire »",
  try_work_passport: "Recherchez « Passeport de travail »",
  try_work_permit: "Recherchez « Permis de travail »",
  upload_documents: "Télécharger des Documents",
  filter_documents: "Filtrer les Documents",
  sort_documents: "Trier les Documents",
  document_name: "Nom du Document",
  uploaded_by: "Téléversé par",
  uploaded_on: "Téléversé le",
  download_document: "Télécharger le document",
  download: "Télécharger",
  downloading: "Téléchargement en cours...",
  retry_upload: "Réessayer les échecs de téléversement",
  account_details: "Détails du Compte",
  reset_password: "Réinitialiser le Mot de Passe",
  name: "Nom",
  first_name: "Prénom",
  last_name: "Nom de famille",
  country: "Pays",
  street_address: "Adresse",
  unit_number: "Numéro<br/ >d’appartement",
  unit_number2: "Numéro d’appartement",
  town_city: "Ville",
  province_state: "Province/État",
  postal_code_zip_code: "Code Postal/ZIP",
  phone: "Téléphone",
  save_changes: "Enregistrer les Modifications",
  search: "Rechercher",
  access_level: "Niveau d'accès",
  everyone_on_file: "Tous les utilisateurs",
  add_documents: "Ajouter des documents",
  apply_to_all: "Appliquer à tous",
  save_password: "Enregistrer le Mot de Passe",
  password_different_notice: "Doit être différent des mots de passe précédents.",
  password_min_length: "Au moins 8 caractères.",
  password_number_special_char: "Au moins 1 chiffre et 1 caractère spécial",
  password_uppercase_char: "Au moins 1 lettre majuscule.",
  old_password: "Ancien Mot de Passe",
  new_password: "Nouveau Mot de Passe",
  reenter_new_password: "Confirmer le Nouveau Mot de Passe",
  document_type: "Type de Document",
  issue_date: "Date d’émission",
  expiry_date: "Date d’expiration",
  initiate_extension_matter: "Initier une Demande de Prolongation",
  how_can_we_help: "Comment pouvons-nous vous aider ?",
  request_details_placeholder: "Veuillez fournir des détails sur votre demande.",
  applicant_details: "Détails du Demandeur",
  applicant_contact: "Coordonnées du candidat",
  title: "Titre",
  given_names_passport: "Prénom(s) – tel qu’indiqué sur le passeport",
  last_name_passport: "Nom de famille – tel qu’indiqué sur le passeport",
  date_of_birth: "Date de naissance",
  nationality: "Nationalité",
  passport_number: "Numéro de passeport",
  email: "Courriel",
  telephone: "Téléphone",
  applicant_documents: "Documents du Demandeur",
  passport_bio_page: "Page biographique du passeport (pour tous les pays de citoyenneté)",
  post_secondary_education_docs: "Diplômes/Certificats d’études postsecondaires",
  resume: "CV",
  resume_description: "Inclure tout l’historique professionnel, les titres de poste, la description des tâches, les lieux, les dates et si l’emploi était à temps plein/partiel",
  canadian_status_document: "Document de statut canadien (le cas échéant)",
  canadian_status_description: "Inclure tous les permis de travail, permis d’études, VRT ou visas d’affaires actuels et/ou antérieurs",
  marriage_certificate: "Certificat de mariage (le cas échéant)",
  accompanying_family_documents: "Documents des Membres de la Famille",
  passport_bios_pages_family: "Pages biographiques des passeports (pour tous les membres de la famille)",
  birth_certificates_dependants: "Certificats de naissance (pour tous les enfants à charge)",
  submit: "Soumettre",
  submit_documents: "Soumettre des documents",
  submitting: "Envoi en cours...",
  active: "Actif",
  in_progress: "En cours",
  pending_review: "En attente de révision",
  closed: "Fermé",
  how_can_we_help_you: "Comment pouvons-nous vous aider ?",
  faqs_intro: "Nous avons rassemblé quelques questions fréquemment posées pour vous. Cliquez sur les liens des questions ci-dessous pour afficher les réponses !",
  tech_question_contact: "Si vous avez une question technique sans réponse ici, veuillez nous contacter à : ",
  case_specific_contact: "Pour toute question spécifique à votre dossier, veuillez contacter votre avocat ou analyste de dossier.",
  i_need_tech_support: "J’ai besoin d’un support technique.",
  tech_issue_instructions: "Si vous rencontrez des problèmes techniques ou avez une question, veuillez fournir les détails ci-dessous ainsi qu’un numéro de téléphone où nous pouvons vous joindre.",
  it_team_contact: "Un membre de notre équipe informatique vous contactera dès que possible pendant les heures de travail.",
  provide_issue_details: "Veuillez fournir les détails du problème que vous rencontrez.",
  how_to_reset_password: "Comment réinitialiser mon mot de passe ?",
  reset_password_instructions: "Pour réinitialiser votre mot de passe :",
  go_to_settings: "Allez dans Paramètres (cliquez sur l’icône X en haut à droite).",
  reset_password_tab: "Cliquez sur l’onglet Réinitialiser le mot de passe.",
  enter_passwords_note: "Entrez votre ancien et nouveau mot de passe. Le nouveau mot de passe doit être différent des précédents, contenir entre 8 et 50 caractères, avec au moins 1 chiffre, 1 caractère spécial et 1 lettre majuscule.",
  click_save_password: "Cliquez sur Enregistrer le mot de passe.",
  accepted_file_formats: "Quels formats de fichiers sont acceptés pour le téléversement ?",
  accepted_file_formats_list: "Nous acceptons les formats suivants : .PDF, .DOC, .DOCX, .PNG, .JPG, .JPEG, .HEIC, .XLS, .XLSX, .CSV, .TXT",
  no_zipped_files: "Veuillez ne pas téléverser de fichiers compressés (.zip).",
  how_to_pay_consultation: "Comment puis-je payer ma consultation ?",
  consultation_payment_url: "Pour payer vos frais de consultation en ligne avec Visa ou Mastercard, veuillez visiter :",
  no_amex_payment: "Nous n’acceptons pas les paiements par American Express (AMEX).",
  how_to_pay_invoice: "Comment puis-je payer ma facture d’honoraires juridiques ?",
  invoice_payment_note: "Vous pouvez payer vos factures Green and Spiegel en ligne avec Visa ou Mastercard :",
  invoice_payment_cad_url: "Pour payer en CAD :",
  invoice_payment_usd_url: "Pour payer en USD :",
  application_time_question: "Combien de temps prendra le traitement de ma demande ?",
  application_time_answer: "Chaque demande est différente et prend un temps variable à traiter. Bien que nous ne puissions pas garantir les délais de traitement gouvernementaux, voici quelques outils utiles :",
  processing_time_url: "Pour consulter les délais moyens selon le type de demande :",
  check_status_url: "Une fois votre demande soumise, vous pouvez vérifier son statut ici :",
  yyyy_mm_dd: "AAAA-MM-JJ",
  details_required: "Les détails concernant la demande sont requis.",
  character_limit: "Limite de caractères : 1 000 caractères.",
  telephone_length: "Le numéro de téléphone doit comporter au moins 10 caractères.",
  check_telephone_format: "Vérifiez le format du numéro de téléphone.",
  email_required: "L'adresse e-mail est requise.",
  email_format_invalid: "La valeur saisie ne correspond pas au format d'une adresse e-mail.",
  invalid_format: "Format invalide.",
  state_required: "L’État/Province est requis(e).",
  email_registered: "Cette adresse e-mail est déjà enregistrée. Veuillez utiliser une autre adresse e-mail.",
  select_title: "Veuillez sélectionner un titre.",
  given_name_required: "Le ou les prénom(s) sont requis.",
  last_name_required: "Le nom de famille est requis.",
  street_address_required: "L’adresse postale est requise.",
  town_city_required: "La ville est requise.",
  country_required: "Le pays est requis.",  
  statusLabelMap: {
    "Active": "Actif",
    "Pending Review": "En Révision",
    "Submitted": "Soumis",
    "Closed": "Fermé",
    "On Hold": "En attente"
  },

  intStatusLabelMap: {
    'Active': 'Actif',
    'Approved': 'Approuvé',
    'Get Started': 'Commencer',
    'Rejected': 'Rejeté',
    'Pending Review': 'En Révision',
  },

  intStatusOptionsFr: [
    { id: '0', label: 'Actif' },
    { id: '2', label: 'Fermé' },
    { id: '3', label: 'En attente' },
    { id: '4', label: 'En Révision' },
    { id: '1', label: 'Soumis' },
  ],

  filterOptionsFr: [
    { id: "1", label: "Actif" },
    { id: "4", label: "Approuvé" },
    { id: "0", label: "Commencer" },
    { id: "2", label: "En Révision" },
    { id: "3", label: "Rejeté" },
  ],

  intStatusOptionsFrExpiry: [
    { id: 'BIOMETRICS', label: 'Date limite pour les données biométriques' },
    { id: 'ID05', label: 'Permis d’études canadien' },
    { id: 'WORKPERMIT', label: 'Permis de travail canadien' },
    { id: 'ID08', label: 'EIMT' },
    { id: 'ID09', label: 'Carte de RP' },
  ],

  sortOptionsFrExpiry: [
    {
      label: "Date d’expiration - Du plus récent au plus ancien",
      value: { orderBy: "expiry", sortOrder: "DESC" },
    },
    {
      label: "Date d’expiration - Du plus ancien au plus récent",
      value: { orderBy: "expiry", sortOrder: "ASC" },
    },
    {
      label: "Type de document - Alphabétique (A à Z)",
      value: { orderBy: "type", sortOrder: "ASC" },
    },
    {
      label: "Type de document - Alphabétique (Z à A)",
      value: { orderBy: "type", sortOrder: "DESC" },
    },
  ],

  sortOptionsFrDashBoard: [
    {
      label: "Numéro du client - Du plus récent au plus ancien",
      value: { orderBy: "clNo", sortOrder: "DESC" },
    },
    {
      label: "Numéro du client - Du plus ancien au plus récent",
      value: { orderBy: "clNo", sortOrder: "ASC" },
    },
    {
      label: "Nom du client - Alphabétique (A à Z)",
      value: { orderBy: "clName", sortOrder: "ASC" },
    },
    {
      label: "Nom du client - Alphabétique (Z à A)",
      value: { orderBy: "clName", sortOrder: "DESC" },
    },
  ],

  sortOptionsFrCompany: [
    {
      label: "Numéro de dossier - Classé en ordre décroissant",
      value: { orderBy: "fileNo", sortOrder: "DESC" },
    },
    {
      label: "Numéro de dossier - Classé en ordre croissant",
      value: { orderBy: "fileNo", sortOrder: "ASC" },
    },
    {
      label: "Nom du demandeur - Alphabétique (A à Z)",
      value: { orderBy: "ApplicantName", sortOrder: "ASC" },
    },
    {
      label: "Nom du demandeur - Alphabétique (Z à A)",
      value: { orderBy: "ApplicantName", sortOrder: "DESC" },
    },
    {
      label: "Statut - Alphabétique (A à Z)",
      value: { orderBy: "intStatus", sortOrder: "ASC" },
    },
    {
      label: "Statut - Alphabétique (Z à A)",
      value: { orderBy: "intStatus", sortOrder: "DESC" },
    },
  ],

  sortOptionsFrApp: [
    {
      label: "Statut - Alphabétique (A à Z)",
      value: { orderBy: "status", sortOrder: "ASC" },
    },
    {
      label: "Statut - Alphabétique (Z à A)",
      value: { orderBy: "status", sortOrder: "DESC" },
    },
  ],

  sortOptionsFrAllMatters: [
    {
      label: "Numéro de dossier — Classé en ordre décroissant",
      value: { orderBy: "fileNo", sortOrder: "DESC" },
    },
    {
      label: "Numéro de dossier - Classé en ordre croissant",
      value: { orderBy: "fileNo", sortOrder: "ASC" },
    },
    {
      label: "Nom du demandeur - Alphabétique (A à Z)",
      value: { orderBy: "ApplicantName", sortOrder: "ASC" },
    },
    {
      label: "Nom du demandeur - Alphabétique (Z à A)",
      value: { orderBy: "ApplicantName", sortOrder: "DESC" },
    },
    {
      label: "Statut - Alphabétique (A à Z)",
      value: { orderBy: "intStatus", sortOrder: "ASC" },
    },
    {
      label: "Statut - Alphabétique (Z à A)",
      value: { orderBy: "intStatus", sortOrder: "DESC" },
    },
  ],

  documentsFilterOptionsFr: [
    { id: "IMAGE", label: "Images" },
    { id: "PDF", label: "PDF" },
    { id: "SPREADSHEET", label: "Feuille de calcul" },
    { id: "DOCUMENT", label: "Word/Documents" },
    { id: "SHELL", label: "Autre" },
  ],

  documentsSortOptionsFr: [
    {
      label: "Date de téléversement - Du plus récent au plus ancien",
      value: { orderBy: "created", sortOrder: "DESC" },
    },
    {
      label: "Date de téléversement - Du plus ancien au plus récent",
      value: { orderBy: "created", sortOrder: "ASC" },
    },
    {
      label: "Nom du document - Alphabétique (A à Z)",
      value: { orderBy: "docDesc", sortOrder: "ASC" },
    },
    {
      label: "Nom du document - Alphabétique (Z à A)",
      value: { orderBy: "docDesc", sortOrder: "DESC" },
    },
    {
      label: "Numéro de dossier - Du plus récent au plus ancien",
      value: { orderBy: "fileNo", sortOrder: "DESC" },
    },
    {
      label: "Numéro de dossier - Du plus ancien au plus récent",
      value: { orderBy: "fileNo", sortOrder: "ASC" },
    },
  ],
  
};
  
export default fr;